import script from "./PageFAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFAQ.vue?vue&type=script&setup=true&lang=js"

import "./PageFAQ.vue?vue&type=style&index=0&id=4aca5987&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aca5987"]])

export default __exports__